import http from "./http";

const getCar = (params, cancelToken) => {
  return http.get("/vehicles/all-vehicles-paginated", {
    params,
    cancelToken,
  });
};

const getCarDetailsById = (params) => {
  return http.get("/vehicles/vehicle-by-id", {
    params,
  });
};

const getHistoryCarById = (params, cancelToken) => {
  return http.get("/drivers/vehicle-used", {
    params,
    cancelToken,
  });
}

const createCar = (data) => {
  return http.post("/vehicles", data);
};

const removeCar = (id) => {
  return http.delete("/vehicles", { 
    params: { id }
  });
};


export default {
  getCar,
  getHistoryCarById,
  getCarDetailsById,
  createCar,
  removeCar
};
